import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  // Remove scrollbar gutter from all pages for consistent layout
  useEffect(() => {
    // Always remove the scrollbar gutter class for consistent spacing across all pages
    document.documentElement.classList.remove('needs-stable-scrollbar');

    // Cleanup on unmount
    return () => {
      document.documentElement.classList.remove('needs-stable-scrollbar');
    };
  }, [location.pathname]);

  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      <Sidebar />
      <div className="flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
};